import React, { useState, useEffect } from "react";
import { setTimer } from 'redux/register/registerSlice'
import { useDispatch } from "react-redux";


const CountdownTimer = ({ minutes, seconds, onTimeout }) => {
  const [timeLeft, setTimeLeft] = useState(minutes * 60 + seconds);
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setTimer(false))

    const timer =
      timeLeft > 0 && setInterval(() => setTimeLeft(timeLeft - 1), 1000);

    return () => clearInterval(timer);
  }, [timeLeft]);

  useEffect(() => {
    if (timeLeft === 0) {
      onTimeout();
         dispatch(setTimer(true))
    }
  }, [timeLeft, onTimeout]);

  const displayMinutes = Math.floor(timeLeft / 60)
    .toString()
    .padStart(2, "0");
  const displaySeconds = (timeLeft % 60).toString().padStart(2, "0");

  return (
    <div>
      {displayMinutes}:{displaySeconds}
    </div>
  );
};

export default CountdownTimer;